import React from "react";
import { AppBar, Toolbar, Typography, IconButton, Box } from "@mui/material";
import logo from "../../img/logo.png";
import { useAppSelector } from "../../app/hooks";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import { IDialog } from "../../app/types";
import { AnchorMenu } from "../Components/index";

/* Functional component properties */
interface Props {
  classes: any;
  handleDialogOpen: (content: IDialog) => void;
  buttonClickHandler: (btn: any) => void;
}

/* React Functional component */
export const AppBarRenderer: React.FC<Props> = ({
  /* Function arguments (Props) */
  classes,
  handleDialogOpen,
  buttonClickHandler,
}): JSX.Element => {
  /* get state */
  const { appBar } = useAppSelector((state) => state);

  return (
    <AppBar id="topbar">
      <Toolbar className={classes.toolbar}>
        {/* Container for logo */}
        <Box className={classes.logoBox}>
          <img src={logo} alt="logo" />
        </Box>

        {/* Container for title and subtitle */}
        <Box className={classes.titleBox}>
          <Box>
            <Typography variant="h5" noWrap>
              {appBar.companyTitle.value}
            </Typography>
          </Box>

          <Box>
            <Typography variant="caption" noWrap>
              {appBar.companySubTitle.value}
            </Typography>
          </Box>
        </Box>

        {/* Flex Container in between to align the right side contents */}
        <Box className={classes.topbarBoxCenter}></Box>

        {/* Container account info */}
        <Box className={classes.profileBox}>
          <Box>
            <IconButton
              aria-label="contact"
              id="contactInfo"
              className={classes.contactBtn}
              onClick={() => handleDialogOpen(appBar.contactInfo)}
            >
              <ContactSupportIcon />
            </IconButton>
          </Box>

          <Box>
            <AnchorMenu
              classes={classes}
              item={appBar.accountInfo.value}
              buttonClickHandler={buttonClickHandler}
              handleDialogOpen={handleDialogOpen}
            />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
